<template>
  <main class="orders">
    <div class="main-container">
      <div class="B-container-back">
        <div class="B-container-menu-float">
          <div class="B-btn-close">X</div>
          <div class="B-container-general">
            <div class="B-container-login">
              <div class="B-tittle">
                <div>
                  <div>
                    ¡QUE ESTÉS AQUÍ, NOS
                  </div>
                  <div>
                    HACE MUY FELICES!
                  </div>
                </div>
              </div>
              <div class="B-container-data">
                <div class="B-row" style="margin-top:15px">
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 1 || userName.length > 0,
                      }"
                    >
                      Nombres
                    </div>
                  </div>
                  <input
                    type="text"
                    class="B-input-name"
                    v-model="userName"
                    @click="inputSelected = 1"
                  />
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 2 || userLastName.length > 0,
                      }"
                    >
                      Apellidos
                    </div>
                  </div>
                  <input
                    type="text"
                    class="B-input-lastname"
                    v-model="userLastName"
                    @click="inputSelected = 2"
                  />
                </div>
                <div class="B-row">
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 3 || userEmail.length > 0,
                      }"
                    >
                      Correo&nbspElectrónico
                    </div>
                  </div>
                  <input
                    type="email"
                    class="B-input-email"
                    v-model="userEmail"
                    @click="inputSelected = 3"
                  />
                </div>
                <div class="B-row">
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 4 || userPhone.length > 0,
                      }"
                    >
                      Telefono
                    </div>
                  </div>
                  <input
                    type="tel"
                    maxlength="10"
                    class="B-input-phone"
                    v-model="userPhone"
                    @click="inputSelected = 4"
                  />
                </div>
                <div class="B-row">
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 5 || userID.length > 0,
                      }"
                    >
                      Nombre&nbspde&nbspusuario
                    </div>
                  </div>
                  <input
                    type="text"
                    class="B-input-username"
                    v-model="userID"
                    @click="inputSelected = 5"
                  />
                </div>
                <div class="B-row">
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 6 || userPassword1.length > 0,
                      }"
                    >
                      Contraseña
                    </div>
                  </div>
                  <input
                    type="password"
                    class="B-input-password"
                    minlength="8"
                    maxlength="16"
                    v-model="userPassword1"
                    @click="inputSelected = 6"
                  />
                </div>
                <div class="B-row">
                  <div class="B-text-float">
                    <div
                      class="B-float"
                      :class="{
                        active: inputSelected == 7 || userPassword2.length > 0,
                      }"
                    >
                      Confirmar&nbspcontraseña
                    </div>
                  </div>
                  <input
                    type="password"
                    class="B-input-password2"
                    v-model="userPassword2"
                    @click="inputSelected = 7"
                  />
                </div>
                <div class="B-row">
                  <div class="B-container-radiobtn">
                    <div class="B-gender male">
                      <label for="gender" style="margin-right:15px"
                        >Hombre</label
                      >
                      <input type="radio" class="B-input-gender" value="male" />
                    </div>
                    <div class="B-gender female">
                      <label for="gender" style="margin-right:19px"
                        >Mujer</label
                      >
                      <input
                        type="radio"
                        class="B-input-gender"
                        value="women"
                      />
                    </div>
                  </div>
                </div>
                <div class="B-row">
                  <button class="B-btn-register">REGISTRATE</button>
                </div>
                <div class="B-row">
                  <div class="B-container-foot">
                    <div
                      style="style=justify-content:center; align-items:center; display:flex"
                    >
                      registrarte, aceptas las &nbsp
                      <a href="/hola"> Condiciones de servicio</a> y &nbsp
                    </div>
                    <div
                      style="justify-content:center; align-items:center; display:flex"
                    >
                      <a href="/hola">Políticas de privacidad</a>&nbsp de &nbsp
                      <a href="/hola">GootWork</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: () => ({
    inputSelected: 0,
    userName: "",
    userLastName: "",
    userEmail: "",
    userPhone: "",
    userID: "",
    userPassword1: "",
    userPassword2: "",
    status: false,
  }),
  methods: {
    checkStatus(indicator) {
      switch (indicator) {
        case 1:
          if (this.userName.length > 0) {
            return true;
          }
          break;
        case 2:
          if (this.userLastName.length > 0) {
            return true;
          }
          break;
        default:
          break;
      }
    },
    getStatus(indicator) {
      this.status = this.checkStatus(indicator);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/modules/new-registro-user.scss";
</style>
